import type { ApiEmail, ApiEmailAttachment } from "src/types/api";
import type {
  Attachment,
  EmailItem,
  EmailStatus,
} from "src/types/conditionsInbox";

export const convertApiEmailToEmailItem = (apiEmail: ApiEmail): EmailItem => ({
  id: apiEmail.id.toString(),
  subject: apiEmail.email_subject,
  sender: apiEmail.sender_email.split("@")[0],
  senderEmail: apiEmail.sender_email,
  receivedAt: apiEmail.received_date_time,
  hasAttachments: apiEmail.attachment_count > 0,
  attachmentCount: apiEmail.attachment_count,
  status: apiEmail.processing_status as EmailStatus,
  body: apiEmail.email_body,
});

const formatFileSize = (bytes: number): string => {
  if (bytes === 0) return "0 Bytes";
  const k = 1024;
  const sizes = ["Bytes", "KB", "MB", "GB"];
  const i = Math.floor(Math.log(bytes) / Math.log(k));
  return parseFloat((bytes / Math.pow(k, i)).toFixed(2)) + " " + sizes[i];
};

const truncateFilename = (filename: string, maxLength: number = 30) => {
  if (filename.length <= maxLength) return filename;

  const extension =
    filename.lastIndexOf(".") > 0
      ? filename.substring(filename.lastIndexOf("."))
      : "";
  const nameWithoutExt = extension
    ? filename.substring(0, filename.lastIndexOf("."))
    : filename;

  const truncatedLength = maxLength - extension.length - 3; // 3 for "..."
  return nameWithoutExt.substring(0, truncatedLength) + "..." + extension;
};

export const convertApiAttachmentsToAttachments = (
  apiAttachments: ApiEmailAttachment[],
): Attachment[] =>
  apiAttachments.map((att) => ({
    id: att.id.toString(),
    name: truncateFilename(att.attachment_name),
    type: att.content_type.split("/")[1] || "unknown",
    size: formatFileSize(att.size_bytes),
  }));
